/* NOTIFICATION ITEM COMPONENT ************************************************/

import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utilities */
import _ from 'lodash'

/* Constants */
import { ERROR, WARNING, STATUS, PROCESS, PROGRESS } from './type'

/* Widgets */
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'

/* Actions */
import {
  pull,
  dismiss,
  stop
} from 'react-redux/actions/notification'

/* Selector */
import {
  getStackItem
} from 'react-redux/selectors/notification'

/* Styles */
import './item.css'

/* Notification Stack component */
class NotificationStackItem extends Component {
  constructor(props) {
    super(props)
    this.state = { stopProcessDialog: false }
  }

  onDismiss(event) {
    const { dismiss } = this.props
    event.stopPropagation()
    dismiss( this.props )
  }

  onStop(event) {
    this.setState({stopProcessDialog: true})
  }

  onConfirmStopProcess(event) {
    const { stop } = this.props
    event.stopPropagation()
    stop( this.props )
    this.setState({stopProcessDialog: false})
  }

  onCancelStopProcess(event) {
    this.setState({stopProcessDialog: false})
  }

  renderIcon() {
    const { t, type, progress, stopped, completed } = this.props
    switch (type) {
      case ERROR:
        return <Icon
          icon={ ICON.ERROR }
          title={ t("notification:icon.error") }
          size={ 36 }
          circle={ true }
          scheme={ ICON_SCHEME.DANGER }
          interactive={ false }
        />
      case WARNING:
        return <Icon
          icon={ ICON.WARNING }
          title={ t("notification:icon.warning") }
          size={ 36 }
          circle={ true }
          scheme={ ICON_SCHEME.WARNING }
          interactive={ false }
        />
      case STATUS:
        return <Icon
          icon={ ICON.INFORMATION }
          title={ t("notification:icon.status") }
          size={ 36 }
          circle={ true }
          scheme={ ICON_SCHEME.READY }
          interactive={ false }
        />
      case PROCESS:
        if (stopped || completed) {
          return <Icon
            icon={ ICON.LOADING_SYNC }
            spin={ false }
            title={ t("notification:icon.process") }
            size={ 36 }
            circle={ true }
            scheme={ ICON_SCHEME.DEFAULT }
            interactive={ false }
          />
        } else {
          return <Icon
            icon={ ICON.LOADING_SYNC }
            spin={ true }
            title={ t("notification:icon.process") }
            size={ 36 }
            circle={ true }
            scheme={ ICON_SCHEME.DEFAULT }
            interactive={ false }
          />
        }
      case PROGRESS:
        if (stopped) {
          return <Icon
            icon={ ICON.OFFLINE }
            spin={ false }
            title={ t("notification:icon.process") }
            size={ 36 } circle={ true }
            scheme={ ICON_SCHEME.ACTION }
            interactive={ false }
          />
        }
        if (completed) {
          return <div className="pie">
            <Icon
              icon={ ICON.ONLINE }
              spin={ false }
              title={ t("notification:icon.process") }
              size={ 36 }
              circle={ true }
              scheme={ ICON_SCHEME.ACTION }
              interactive={ false }
            />
          </div>
        }
        let style
        if(progress <.5){
          style = {
            backgroundImage: 'linear-gradient('+((progress*360)+90)+'deg, transparent 50%, white 50%), linear-gradient(90deg, white 50%, transparent 50%)'
          }
        } else {
          style = {
            backgroundImage: 'linear-gradient('+((progress*360)-90)+'deg, transparent 50%, #2323DF 50%), linear-gradient(90deg, white 50%, transparent 50%)'
          }
        }
        return <div className="pie" style={ style }>
          <Icon
            icon={ ICON.LOADING_SYNC }
            spin={ true }
            title={ t("notification:icon.process") }
            size={ 36 }
            circle={ true }
            scheme={ ICON_SCHEME.ACTION }
            interactive={ false }
          />
        </div>
    }
    return  <Icon
      icon={ ICON.INFORMATION }
      title={ t("notification:icon.information") }
      size={ 36 }
      circle={ true }
      scheme={ ICON_SCHEME.DEFAULT }
      interactive={ false }
    />
  }

  renderConfirmDialog() {
    const { stopProcessDialog } = this.state
    if (!stopProcessDialog) return
    const { t, message, detail, uid } = this.props
    return (
      <RemoveDialog
        text={ t("notification:stack.cancelDialogText") }
        scheme={ REMOVE_DIALOG_SCHEME.REMOVE }
        onCancel={ this.onCancelStopProcess.bind(this) }
        cancelLabel={ t("notification:stack.cancelButtonLabel") }
        onConfirm={ this.onConfirmStopProcess.bind(this) }
        confirmLabel={ t("notification:stack.confirmButtonLabel") }
        />
    )
  }

  renderStopProcessButton() {
    const { t, unstoppable, type, stopped } = this.props
    if (type != PROGRESS || unstoppable || stopped) return null
    return (
      <button
        onClick={ this.onStop.bind(this) }
        title={ t("notification:stack.stopProcessButtonTitle") }
      >
        <Icon icon={ ICON.DELETE } interactive={ true } size={ 24 } circle={ false } />
      </button>
    )
  }

  renderDismissButton() {
    const { t, listItem } = this.props
    if (listItem) return
    return <button
      onClick={ this.onDismiss.bind(this) }
      title={ t("notification:stack.dismissButtonTitle") }
    >
      <Icon icon={ ICON.ERROR } interactive={ true } size={ 24 } circle={ false } />
    </button>
  }

  renderDetail() {
    const { detail } = this.props
    if (typeof detail === "object") {
      return (
        _.map(detail, (v, k) => {
          return <div>{ k + ": " + JSON.stringify(v) }</div>
        })
      )
    } else if (!_.isNil(detail)) {
      return <div>{ detail.toString() }</div>
    }
    return null
  }

  render() {
    const { t, message, detail, uid } = this.props
    return (
      <li
        key={uid}
        className="notification-stack-item component"
      >
        <div className="type">
          { this.renderIcon() }
        </div>
        <div className="content">
          <div className="message">
            { t('notification:message.' + message) }
          </div>
          <div className="detail">
            { /*this.renderDetail()*/ }
          </div>
        </div>
        <div className="toolbar">
          { this.renderStopProcessButton() }
          { this.renderDismissButton() }
        </div>
        { this.renderConfirmDialog() }
      </li>
    )
  }
}

NotificationStackItem.propTypes = {
  listItem: PropTypes.bool
}

function mapStateToProps(state) {
  return Object.assign(
    {},
    state
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pull,
      dismiss,
      stop
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getStackItem(stateProps, ownProps.uid),
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NotificationStackItem)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/notification/item.jsx